import { CheckOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { FC } from 'react'
import useSuccessModal from '../../../../../hooks/api/use-success-modal'
import useErrorModal from '../../../../../hooks/api/use-error-modal'
import { useUpdateFormOrderMutation } from '../../../../../store/api/form-orders-api'


interface AcceptProps {
    documentId: string
    disabled?: boolean
}

const Accept: FC<AcceptProps> = ({ documentId, disabled = false }) => {
    const [updateFormOrder, updateState] = useUpdateFormOrderMutation()

    const onClick = () => {
        updateFormOrder({
            docId: documentId,
            body: {
                data: {
                    orderStatus: 'Завершен',
                },
            },
        })
    }

    useErrorModal(updateState, 'Ошибка оформления прихода форм')
    useSuccessModal(updateState, 'Формы успешно оформлены')

    return (
        <Button
            size={'small'}
            icon={<CheckOutlined />}
            color='green'
            variant={'outlined'}
            title={
                disabled
                    ? 'Отметьте все формы как «В наличии» или зафиксируйте брак'
                    : 'Принять заказ'
            }
            onClick={onClick}
            loading={updateState.isLoading}
            disabled={disabled}
        />
    )
}
export default Accept